import { CONTENT_OVERVIEW_ROUTES } from '~/elc/features/admin-content-overview/constants';
import { consumer } from '~/lib/rails-actioncable';

export const useContentProviderContentCreatedSubscription = () => {
  const createSubscription = ({ contentId, enterpriseId }: { contentId: string; enterpriseId: number }) => {
    const handleBroadcastReceived = (data, subscription) => {
      const { topLevelContentId } = data;
      subscription.unsubscribe();
      window.location.href = `${CONTENT_OVERVIEW_ROUTES.content_provider_content}/${topLevelContentId}`;
    };

    const subscription = consumer.subscriptions.create(
      {
        channel: 'ContentProviderContents::ContentCreationCompletedChannel',
        content_id: contentId,
        enterprise_id: enterpriseId,
      },
      {
        received: (data) => handleBroadcastReceived(data, subscription),
      },
    );
  };

  return { createSubscription };
};
